import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Utils } from "@/shared/utils/utils";
import store from "@/store";
import Vue from "vue";
import Component from "vue-class-component";
import { Inject, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import {
  DASHBOARD_TEMPLATE_EVENTS,
  DATA_TYPE,
  SPECIAL_FIELDS,
  SPECIAL_FIELDS_MAP,
  SPECIAL_FIELDS_VALUES,
  USER_ID_FIELD
} from "../../constants/DashboardTemplatesConstants";
import {
  FilterField,
  FilterOfCollection
} from "../../models/FilterOfCollection";
import {
  EventChart,
  SectionOfDashboard
} from "../../models/SectionOfDashboard";

import { cloneDeep } from "lodash";
import DashboardFilter from "../DashboardFilter/DashboardFilter.vue";
import { UserService } from "@/modules/User/services/UserService";
import { Http } from "@status/codes";
import { SelectCollection } from "../DashboardFilter/logic/SelectCollection";

@Component({
  name: "DashboardFilterGroup",
  components: { DashboardFilter },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      actionInFilters: "getActionInFilters",
      eventChart: "getEventChart"
    })
  }
})
export default class DashboardFilterGroup extends Vue {
  @Inject() userService!: UserService;

  @Prop() filters!: FilterOfCollection[];
  @Prop() indexSectionOfDashboard!: number;
  @Prop() indexCollectionFilter!: number;
  @Prop() collection!: DynamicSelectData[];
  @Prop() groupBy!: DynamicSelectData[];
  @Prop() seeBy!: DynamicSelectData[];
  @Prop({ default: false }) waitingEventGraph!: boolean;
  @Prop({ default: false }) modal!: boolean;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  addItem = GENERAL_CONSTANTS.ICONS.ADD;

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  updatingFilters = false;

  actionInFilters!: {
    indexSection: number;
    indexCollection: number;
    indexFilter: number;
    field: string;
  };

  eventChart!: EventChart;
  filtersLocal: FilterOfCollection[] = [];
  filterEditing: boolean[] = [];
  indexSectionLocal = 0;
  indexCollectionLocal = 0;
  fromModal = false;
  mounted() {
    this.fromModal = this.modal || false;
    this.filterEditing = new Array(this.filters.length).fill(false);
    this.filtersLocal = cloneDeep(this.filters);
    this.updateIndexSectionLocal();
    this.updateIndexCollectionLocal();
    if (this.waitingEventGraph) {
      this.changeEventChart();
    }
  }
  @Watch("indexSectionOfDashboard")
  updateIndexSectionLocal() {
    this.indexSectionLocal = this.indexSectionOfDashboard;
  }

  @Watch("indexCollectionFilter")
  updateIndexCollectionLocal() {
    this.indexCollectionLocal = this.indexCollectionFilter;
  }

  onUpdateQuery(event?: boolean) {
    if (this.updatingFilters) {
      return;
    }
    this.$emit("updateQuery", event);
  }

  addFilter() {
    this.filterEditing.push(false);
    const id = Utils.idGenerator();

    this.filtersLocal.push({ field: [], operator: [], value: [], id });

    store.commit(DASHBOARD_TEMPLATE_EVENTS.ADD_FILTER, {
      indexSectionOfDashboard: this.indexSectionLocal,
      index: this.indexCollectionLocal,
      onefilter: { field: [], operator: [], value: [], id }
    });
  }

  onFilterDeleted(indexFilter: number, valueFilled: boolean, fieldId: string) {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.DELETE_FILTER, {
      indexSectionOfDashboard: this.indexSectionLocal,
      indexCollection: this.indexCollectionLocal,
      indexFilter
    });

    this.filtersLocal.splice(indexFilter, 1);
    this.filterEditing.splice(indexFilter, 1);
    if (valueFilled) {
      this.onUpdateQuery();
    }

    const validateSpecialCaseInfoForm = this.verifThisFieldBelongToSpecialCaseInForm(
      fieldId
    );
    if (validateSpecialCaseInfoForm) {
      this.$emit(DASHBOARD_TEMPLATE_EVENTS.SPECIAL_FIELD_SELECTED, false);
    }
  }

  verifThisFieldBelongToSpecialCaseInForm(fieldId: string) {
    if (
      this.collection[0].id !== "forms" &&
      this.collection[0].id !== "services"
    ) {
      return false;
    }

    if (SPECIAL_FIELDS.includes(fieldId)) {
      return true;
    }

    return false;
  }

  onAddNewField(data: { field: string; visualField: string; fields: any[] }) {
    this.collection[0].fields.push(data);
    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FIELDS_TO_STORE, {
      indexSectionOfDashboard: this.indexSectionLocal,
      indexCollectionFilter: this.indexCollectionLocal,
      fields: this.collection[0].fields,
      collectionId: this.collection[0].id
    });
    this.$emit("updateCollection");
  }

  onRemoveField(data: string) {
    this.collection[0].fields = this.collection[0].fields.filter(
      (item: any) => item.field !== data
    );

    const indexFilter = this.sectionsOfDashboardStore[
      this.indexSectionLocal
    ].collections[this.indexCollectionLocal].filters.findIndex(
      (item: FilterOfCollection) => (item.field[0] as FilterField)?.id == data
    );

    if (indexFilter < 0) {
      return;
    }

    if (this.fromModal) {
      this.fromModal = false;
      return;
    }

    store.commit(DASHBOARD_TEMPLATE_EVENTS.DELETE_FILTER, {
      indexSectionOfDashboard: this.indexSectionLocal,
      indexCollection: this.indexCollectionLocal,
      indexFilter: indexFilter
    });

    const filters = cloneDeep(
      this.sectionsOfDashboardStore[this.indexSectionLocal].collections[
        this.indexCollectionLocal
      ].filters
    );

    filters.splice(indexFilter, 1);
    this.filtersLocal = cloneDeep(filters);
  }

  onRemoveFormFields() {
    const fieldsForDelete = this.collection[0].fields.filter(
      (item: any) => item.isFormField
    );
    for (const fieldForDel of fieldsForDelete) {
      this.onRemoveField(fieldForDel.field);
    }
  }

  getField(filter: FilterOfCollection) {
    if (filter?.id) {
      return filter.id;
    }
    if (!filter.field) {
      return;
    }
    if (typeof filter.field == "string") return filter.field;
    return filter.field[0]?.id;
  }

  get disableAddButton() {
    return !this.collection[0]?.id || this.filterEditing.some(edit => edit);
  }

  onIsFilterEditing(filled: boolean, index: number) {
    this.$set(this.filterEditing, index, filled);
  }

  onAditionalConditionsApplied() {
    if (!this.updatingFilters) {
      return;
    }
    this.updateFilters();
  }

  @Watch("eventChart")
  changeEventChart() {
    if (
      this.indexCollectionLocal != this.eventChart.indexCollection ||
      this.indexSectionLocal != this.eventChart.indexSection
    ) {
      return;
    }
    this.updatingFilters = true;
    this.updateFilters();
  }

  private async updateFilters() {
    try {
      const groupByIds = this.groupBy.map(item => item.id);
      const newFilters = this.collection[0].fields.filter((option: any) =>
        groupByIds.includes(option.field)
      );
      if (newFilters.length == 0 && newFilters.length < groupByIds.length) {
        return;
      }
      const filtersCopy = cloneDeep(
        this.sectionsOfDashboardStore[this.indexSectionLocal].collections[
          this.indexCollectionLocal
        ].filters
      );
      for (const item of newFilters) {
        const indexGroup = this.groupBy.findIndex(
          groupBy => groupBy.id == item.field
        );
        if (this.eventChart.values[indexGroup] == "Ninguno(a)") {
          continue;
        }
        let { operator, value } = await this.determineOperatorAndValue(
          item,
          this.eventChart.values[indexGroup]
        );
        if (item.type == DATA_TYPE.TIME_STAMP && this.seeBy.length > 0) {
          operator = [{ id: "BETWEEN", name: "Entre" }];
          value = this.fixRange(this.eventChart.values[indexGroup], this.seeBy);
        }
        if (item.type == DATA_TYPE.TIME_UNIT) {
          if (operator[0].id !== "BETWEEN") {
            value = [this.eventChart.values[indexGroup]];
          }
          item.description = "year";
        }

        let id = item.field;
        let name = item.visualField;

        const { key, finalValue } = this.getSpecialFieldsValues(
          this.eventChart.values[indexGroup],
          indexGroup
        );
        if (key) {
          id = key;
          name = finalValue;
        }
        const filterToAdd = {
          field: [
            {
              child: item.child,
              id,
              type: item.type,
              idList: item.idList,
              name,
              description: item.description,
              operators: item.operators
            }
          ],
          operator,
          value,
          filterFromChart: true
        };

        const indexFilter = filtersCopy.findIndex(
          item => (item.field[0] as FilterField).id == filterToAdd.field[0].id
        );
        if (indexFilter >= 0) {
          const existingValue = filtersCopy[indexFilter].value[0 as number];
          if (
            typeof existingValue === "object" &&
            existingValue !== null &&
            "fields" in existingValue
          ) {
            (filterToAdd.value[0] as {
              id: string;
              name: string;
              fields?: object;
            }).fields = existingValue.fields;
          }
          filtersCopy[
            indexFilter
          ] = (filterToAdd as unknown) as FilterOfCollection;
        } else {
          filtersCopy.push((filterToAdd as unknown) as FilterOfCollection);
        }
      }
      this.filtersLocal = filtersCopy;
    } catch (error) {
      console.error("error", error);
      // Error handling
    }
    this.updatingFilters = false;
  }

  async getUserId(document: string) {
    const response = await this.userService.getUserByFilters({
      userDocument: document
    });
    if (response.code === Http.Found) {
      return response.data?.userArray[0].id;
    }
    return null;
  }

  fixRange(value: string, seeBy: DynamicSelectData[]) {
    for (const element of seeBy) {
      return this[`calculateRange${element.id}` as keyof DashboardFilterGroup](
        value
      );
    }
  }

  calculateRangemonth(value: string) {
    const [year, month] = value.split("-").map(Number);
    const start = `${year}-${String(month).padStart(2, "0")}-01`;
    const lastDay = new Date(year, month, 0).getDate();
    const end = `${year}-${String(month).padStart(2, "0")}-${String(
      lastDay
    ).padStart(2, "0")}`;
    return [start, end];
  }

  /*   calculateRangeweek(value: string) {
    // Week calculation
  }
  calculateRangeday(value: string) {
    // Day calculation
  } */

  calculateRangeyear(value: string) {
    const start = `${value}-01-01`;
    const end = `${value}-12-31`;
    return [start, end];
  }

  private async determineOperatorAndValue(
    item: any,
    eventValue: string
  ): Promise<{
    operator: { id: string; name: string }[];
    value: { id: string; name: string }[] | string[] | string;
  }> {
    const defaultOperator = [{ id: "=", name: "=" }];
    const betweenOperator = [{ id: "BETWEEN", name: "Entre" }];
    const values = eventValue.split("-");

    if (item.field == USER_ID_FIELD) {
      const userId = await this.getUserId(eventValue);
      if (userId) {
        return {
          operator: defaultOperator,
          value: [{ id: userId, name: eventValue }]
        };
      }
      return {
        operator: defaultOperator,
        value: [{ id: eventValue, name: eventValue }]
      };
    }

    if (item.type == DATA_TYPE.TIME_UNIT && values.length === 2) {
      return { operator: betweenOperator, value: values };
    }

    // Caso 1: Es un número finito
    if (Number.isFinite(Number(eventValue))) {
      const value =
        item.type === "list"
          ? [{ id: eventValue, name: eventValue }]
          : eventValue;
      return { operator: defaultOperator, value };
    }
    // Caso 2: Es un rango numérico (BETWEEN)
    if (item.type === DATA_TYPE.NUMBER && values.length === 2) {
      return { operator: betweenOperator, value: values };
    }
    if (this.collection[0].id === "services") {
      if (item.field === "sectionKey") {
        const selectCollection = new SelectCollection();
        const listOfPropertiesValues =
          selectCollection[this.collection[0].id as keyof SelectCollection];
        listOfPropertiesValues.setIndexes(
          this.indexSectionOfDashboard,
          this.indexCollectionFilter!
        );
        const fetchData = await listOfPropertiesValues.loadItems(
          item.field,
          "",
          "",
          ""
        );
        const section = fetchData.data.find(item => item.name === eventValue);
        const objectValue = [
          {
            id: section?.id,
            name: section?.name
          }
        ] as { id: string; name: string }[];
        return { operator: defaultOperator, value: objectValue };
      }
    }
    // Caso 3: Es un valor de texto/objeto
    const objectValue = [
      {
        id: eventValue,
        name: eventValue
      }
    ] as { id: string; name: string }[];

    return { operator: defaultOperator, value: objectValue };
  }

  getSpecialFieldsValues(eventValue: string, indexGroup: number) {
    try {
      if (
        this.collection[0].id === "forms" ||
        this.collection[0].id === "services"
      ) {
        if (
          SPECIAL_FIELDS_VALUES.includes(this.eventChart.values[indexGroup])
        ) {
          return SPECIAL_FIELDS_MAP[eventValue] ?? { key: "", finalValue: "" };
        }
      }
      return { key: "", finalValue: "" };
    } catch (error) {
      return { key: "", finalValue: "" };
    }
  }
}
